import type { JSX } from 'react';
import { Box, IconButton, Text } from '@ksyos/design-system';
import type { ObesiQQuestionnaireName } from '@common/customControls/bariatrics';
import type { IProcessQuestionnaireResponse } from '@common/interfaces/api/processQuestionnaireResponsesApi';
import type { IQuestionnaireItem } from '@common/interfaces/api/questionnairesApi';
import { obesiQTranslations } from '@common/customControls/bariatrics';
import { ObesiQScoreBar } from './ObesiQScoreBar';
import { ObesiQTable } from './ObesiQTable';

interface IObesiQCardFooterProps {
    onPageChange: (page: number) => void;
    page: number;
    processQuestionnaireResponses: IProcessQuestionnaireResponse[];
    questionnaireItems: IQuestionnaireItem[];
    questionnaireName: ObesiQQuestionnaireName;
}

export function ObesiQCardFooter(props: IObesiQCardFooterProps): JSX.Element | null {
    const { page, processQuestionnaireResponses, questionnaireItems, questionnaireName } = props;

    if (!page) {
        return null;
    }

    return (
        <Box mt={4}>
            <Box
                alignItems="center"
                display="flex"
                mb={6}
            >
                <IconButton
                    icon="caret-left"
                    onClick={() => props.onPageChange(page - 1)}
                    size="small"
                    sx={{
                        opacity: page > 1 ? '1' : '0',
                    }}
                    variant="filled"
                />
                <Box
                    alignItems="center"
                    display="flex"
                    gap={2}
                    mx={4}
                >
                    <Text fontWeight="bold">Vragenlijst meetmoment</Text>
                    <Text
                        fontWeight="bold"
                        sx={{
                            width: 10,
                        }}
                        textAlign="center"
                    >
                        {page}
                    </Text>
                </Box>

                {page < processQuestionnaireResponses.length && (
                    <IconButton
                        icon="caret-right"
                        onClick={() => props.onPageChange(page + 1)}
                        size="small"
                        variant="filled"
                    />
                )}
            </Box>
            <Box
                backgroundColor="neutral50"
                mb={10}
                px={[8, null, 12]}
                py={9}
            >
                <ObesiQScoreBar
                    processQuestionnaireResponse={processQuestionnaireResponses[page - 1]}
                    questionnaireName={questionnaireName}
                />

                <Text
                    fontWeight="medium"
                    mb={6}
                    mt={10}
                >
                    {obesiQTranslations[questionnaireName].description}
                </Text>

                <ObesiQTable
                    processQuestionnaireResponse={processQuestionnaireResponses[page - 1]}
                    questionnaireItems={questionnaireItems}
                />
            </Box>
        </Box>
    );
}
